export const environment = {
  privacyPolicyLink: 'https://www.onlypawspetinsurance.co.uk/privacy-policy/',
  functionAppUrl: 'https://api.onlypawspetinsurance.co.uk/contact-form',
  contactErrorEmail: 'info@onlypawspetinsurance.co.uk',
  BrandCode: 'OnlyPaws',
  captchaSiteKey: '6Lcb4KUrAAAAACdLW4GYpj0Mf7eWf_sgJ_NcAcdo'
};
